/* eslint-env browser */

'use strict';

var CellEditor = require('./CellEditor');

/**
 * @constructor
 * @extends CellEditor
 */
var Select = CellEditor.extend('Select', {

	/**
	 * the list of items to pick from
	 * @type {array}
	 * @memberof Select.prototype
	 */
	items: ['a', 'b', 'c'],

	template: [
		'<div class="container" style="position:relative">',
			'<select id="editor">',
				'{{#items}}',
					'<option value="{{.}}">{{.}}</option>',
				'{{/items}}',
			'</select>',
		'</div>'
	].join('\n'),

	initialize: function(grid, options) {
		var self = this;
		this.input = this.el.getElementsByTagName('select')[0];
		this.input.onchange = function() {
			self.stopEditing();
		};
	},

	/**
	 * @desc hide the editor
	 * @memberof Select.prototype
	 * @override CellEditor.prototype
	 */
	hideEditor: function() {
		if (window.jQuery && window.jQuery.fn.selectpicker) {
			window.jQuery(this.el).find('.dropdown-menu.inner').off('.nx');
			window.jQuery(this.input).selectpicker('destory');
		}
		this.el.style.display = 'none';
	},

	/**
	 * @memberof Select.prototype
	 * @override CellEditor.prototype
	 */
	showEditor: function() {
		var self = this;
		this.el.style.display = 'inline-block';
		if (window.jQuery && window.jQuery.fn.selectpicker) {
			window.jQuery(this.input).selectpicker({
				dropupAuto: false
			});
			var $el = window.jQuery(this.el).find('.dropdown-menu.inner');
			if (checkOverflow($el[0])) {
				$el.off('.nx').on('DOMMouseScroll.nx mousewheel.nx', function(e) {
					e.stopPropagation();
				});
			}
		}
		setTimeout(function() {
			self.showDropdown();
		}, 50);
	},

	/**
	 * @memberof Select.prototype
	 */
	showDropdown: function() {
		if (window.jQuery && window.jQuery.fn.selectpicker) {
			var $el = window.jQuery(this.el).find('.btn-group.bootstrap-select');
			if (!$el.hasClass('open')) {
				window.jQuery(this.input).data('selectpicker').$button.trigger('click');
			}
		} else {
			var event = document.createEvent('MouseEvents');
			event.initMouseEvent('mousedown', true, true, window);
			this.input.dispatchEvent(event);
		}
	}
});

function checkOverflow(el) {
	var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
	return isOverflowing;
}

module.exports = Select;